import { useRef } from 'react';
import './TilesComponent.css';
import { useScrolledInto, useScrollFrame } from '../responsive/scroll';
import googleMapsIcon from '../Images/Google_Maps_icon.svg';
import orbiinIcon from '../Images/orbiin_logo_white.png';
import wazeIcon from '../Images/waze-app-icon.svg';
import congestionImg from '../Images/nyc-congestion-stock.jpg';

// Where the traffic photo sits at the start of the parallax, and how far it drifts
const trafficImgPosition = (ratio) => ({
    left: `-${450 + ratio * 60}px`,
    top: `-${500 + ratio * 10}px`,
});

const TilesComponent = () => {
    const sectionRef = useRef(null);
    const trafficImgRef = useRef(null);
    // Tiles appear in three waves (were scrollPosition > 650, > 750 and > 1070)
    const showLogo = useScrolledInto(sectionRef, 0.674);
    const showRow2 = useScrolledInto(sectionRef, 0.544);
    const showRow3 = useScrolledInto(sectionRef, 0.128);

    // Traffic photo parallax, updated directly each frame instead of re-rendering React.
    // ratio runs 0 → 1 as the section top moves from ~the bottom of the screen to the top.
    const parallaxRatio = (rect, vh) => (1.065 * vh - rect.top) / (1.107 * vh);
    useScrollFrame(sectionRef, (rect, vh) => {
        const img = trafficImgRef.current;
        if (!img) return;
        const pos = trafficImgPosition(parallaxRatio(rect, vh));
        img.style.left = pos.left;
        img.style.top = pos.top;
    });

    const pixayLogoBox = () => <div className='logo-box grid-parent hero-title yellow black-bg tile-title-size'>PIXAY</div>
    const appBox = () => (
        <div className='app-box grid-parent'>
            <img id='google-maps-icon' src={googleMapsIcon} alt='Google Maps Icon'/>
            <img id='orbiin-icon' src={orbiinIcon} alt='Orbiin Icon'/>
            <img id='waze-icon' src={wazeIcon} alt='Waze Icon'/>
        </div>
    )
    const congestionBox = () => {
        const rect = sectionRef.current ? sectionRef.current.getBoundingClientRect() : null;
        return <div className='congestion-box'>
            <img 
                ref={trafficImgRef}
                id='city-traffic-img' 
                src={congestionImg} 
                alt='City Traffic' 
                style={trafficImgPosition(rect ? parallaxRatio(rect, window.innerHeight) : 0.47)}
            />
        </div>
    }
    const boostBox = () => {
        return <div className="boost-box grid-parent">
                <span id="we">WE</span>
                <span id="boost" className="fat-text">BOOST</span>
                <span id="your">YOUR</span> 
                <span id="drive">DRIVE</span>
            </div>
    }
    const withAI = () => {
        return <div className="with-ai-box grid-parent">
            <span className="with-layout">
                with
            </span>
            <span className="ai-layout">
                <span id="artificial">
                    A
                </span>
                <span id="intelligence">
                    I
                </span>
            </span>
        </div>
    }
    const orbiinBox = () => <div className="orbiin-box grid-parent"><span className="orbiin-layout">orbiin</span><span className="movement-layout">Movement Made Intelligent</span></div>
    const r2Box = () => <div className="r2-box grid-parent"><span className="r-layout">R</span><div className="two-layout">2</div></div>
    
    return <div ref={sectionRef} className="viewport grid-parent tiles-layout">
        {showLogo ? pixayLogoBox() : ''}
        {showRow2 ? appBox() : ''}
        {showRow2 ? congestionBox() : ''}
        {showRow2 ? boostBox() : ''}
        {showRow3 ? withAI(): ''}
        {showRow3 ? orbiinBox() : ''}
        {showRow3 ? r2Box() : ''}
    </div>
}

export default TilesComponent;